import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthorizerUsers, User } from 'src/app/shared/model/user.model';
import { Observable, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CreateRelativeBody,
  RelativeUser
} from 'src/app/shared/model/relative.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  urlUsers =
    environment.env === 'dev'
      ? 'https://' + `${environment.API_CONTEXT}/user-service`
      : `${environment.API_CONTEXT}/user-service`;

  constructor(private http: HttpClient) {}

  getUser(login = false): Observable<User> {
    const params = new HttpParams().set('login', login);
    return this.http.get<User>(`${this.urlUsers}/users/nis`, {
      params: params
    });
  }

  getEmails(nis: string[]) {
    return this.http
      .post(`${this.urlUsers}/users-email/emails`, { nis: nis })
      .pipe(
        tap((resp: any) => {
          return resp;
        })
      );
  }

  getUserIsValid(nis: string) {
    const params = new HttpParams().set('nis', nis);
    return this.http.get(`${this.urlUsers}/validation/validate`, {
      params: params
    });
  }

  getUserRequestDelegate(nis: string) {
    const params = new HttpParams().set('nis', nis);
    return this.http.get(`${this.urlUsers}/users/request-delegate`, {
      params: params
    });
  }

  getAuthorizeUsers(
    authorizerType: string,
    requestType: string,
    name?: string
  ) {
    const params = new HttpParams()
      .set('authorizerType', authorizerType)
      .set('requestType', requestType);
    if (name) {
      params.set('name', name);
    }

    return this.http.get<AuthorizerUsers[]>(
      `${this.urlUsers}/users/authorizers`,
      {
        params: params
      }
    );
  }

  getUserExists(nis: string) {
    const params = new HttpParams().set('nis', nis);
    return this.http.get(`${this.urlUsers}/validation/exists`, {
      params: params
    });
  }

  getUserNisName(nis: string): Observable<string> {
    return this.http.get(`${this.urlUsers}/users/${nis}/name`, {
      responseType: 'text'
    });
  }

  getUsersName(name: string) {
    const params = new HttpParams().set('name', name);
    return this.http.get<User[]>(`${this.urlUsers}/users/name`, {
      params: params
    });
  }

  isPec(category: string): boolean {
    const pecCategories = [
      'MK',
      'AT',
      'OMK',
      'TMK',
      'PEC',
      'VICE',
      'PRESI',
      'PEC30'
    ];
    return pecCategories.some((cat) => cat === category);
  }

  updateUser(body: any) {
    return this.http.put(`${this.urlUsers}/users`, body);
  }

  getRelatives(): Observable<RelativeUser[]> {
    return this.http
      .get<{
        data: { users: RelativeUser[] };
      }>(`${this.urlUsers}/users/relatives`)
      .pipe(map((resp) => resp.data.users));
  }

  createRelative(body: CreateRelativeBody) {
    return this.http.post(`${this.urlUsers}/users/relatives`, body);
  }

  updateRelativeStatus(relativeId: string, status: boolean) {
    const params = new HttpParams().set('status', status);
    return this.http.put(
      `${this.urlUsers}/users/relatives/${relativeId}`,
      {},
      { params }
    );
  }
}
